import React, { useMemo } from 'react';

import Conditional from '../../../common/conditional';
import CustomSection from '../custom-section';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import { Column } from '../../../../utils/models';
import { getChunkedData } from '../../../../utils/utilities';

import { getReportDetails } from '../../../../store/reportDetails';
import { useAppSelector } from '../../../../store/configureStore';

interface CustomSummaryProps<T> {
	data: T[];
	summary: string;
	columns: Column[];
}

const CustomSummary = <T extends {}>({ columns, data, summary }: CustomSummaryProps<T>) => {
	const { itemCountPerPage } = useAppSelector(getReportDetails);

	const mappedData = useMemo(() => data.map((item, index) => ({ ...item, id: index + 1 })), [data])
	const chunkedData = useMemo(() => getChunkedData(mappedData, itemCountPerPage), [mappedData, itemCountPerPage]);
	
	return (
		<Conditional isVisible={data.length > 0}>
			{chunkedData.map((chunk, index) => (
				<CustomSection sectionTitle="Summary" key={index}>
					<div className="p-2">
						<PDFTablePage data={chunk} columns={columns} />
					</div>
				</CustomSection>
			))}
		</Conditional>
	);
};

export default CustomSummary;
